import { prefixObjectValues } from '../utils';

const delegation = {
  banner: 'banner',
  providerName: 'provider-name',
  exitBtn: 'exit-btn',
};

export default prefixObjectValues(delegation, 'delegation');
